module.exports = __webpack_public_path__ + "static/media/sms.f809b051.svg";